import Flickity from 'flickity';

const MediaTextarea = () => {

    const sliders = document.querySelectorAll('.media-textarea__slider');

    Array.from(sliders).forEach(slider => {

        if (typeof slider != "undefined" && slider != null) {
            
            new Flickity( slider, {
                adaptiveHeight: true,
                autoPlay: false,
                cellSelector: '.media-textarea__slide',
                lazyLoad: false,
                pageDots: true,
                wrapAround: true,
                draggable: false,
                prevNextButtons: false
            });
        }
    });
}

export default MediaTextarea;